<template>
  <div style="display:flex; align-items:center">
      <span class="el-input__prefix" style="z-index:5; margin-right:15px">
        <span
          class="el-input__prefix-inner"
          @click="isPswVisible = !isPswVisible"
        >
          <i class="el-input__icon el-icon-view" />
        </span>
      </span>
      <el-input
        v-model="password"
        :type="input_type"
        suffix-icon="el-icon-lock"
        v-validate="'required'"
        placeholder="رمز کاربری"
        name="password"
        style="text-align:right;z-index:2;"
        autocomplete="off"
      />
    <div class="level-container">
      <div :class="strength_level"></div>
    </div>
  </div>
  <!-- <ul>
      <li
        v-for="(rule, index) in rules"
        :key="index"
        v-if="rule_status[index] !== 'passed'"
        :class="rule_status[index]"
      >
        <span v-if="rule_status[index] === ''" class="fas fa-times"></span>
        <span v-else class="fas fa-check"></span>
        {{ rule.label }}
      </li>
    </ul> -->
</template>
<script>
import crypto from 'crypto'
import https from 'https'
export default {
  name: 'Test',
  props: {
    validationRules: { type: [Array], default: () => [] }
  },
  data: function() {
    return {
      isPswVisible: false,
      rules: [
        {
          title: 'characterLength',
          label: 'Password length 8 or more characters',
          passed: false,
          check: this.checkPswLength
        },
        {
          title: 'oneLowercase',
          label: 'At least one lowercase character found',
          passed: false,
          check: this.checkPswLowercase
        },
        {
          title: 'oneUppercase',
          label: 'At least one uppercase character found',
          passed: false,
          check: this.checkPswUppercase
        },
        {
          title: 'oneNumber',
          label: 'At least one number found',
          passed: false,
          check: this.checkPswDigit
        },
        {
          title: 'oneSpecial',
          label: 'At least one special character found',
          passed: false,
          check: this.checkPswSpecialChars
        }
      ],
      password: '',
      timerId: null,
      hash: null,
      strength: 0,
      propRules: []
    }
  },
  methods: {
    setEvent(){
      let iconView = document.querySelector('.el-icon__perfix .el-icon-view')
      console.log(iconView)
      iconView.addEventListener('click' , (e)=>{console.log(e.target)})
    },
    checkPswLength: function() {
      return this.password.length >= 8
    },
    checkPswLowercase: function() {
      return /[a-z]+/.test(this.password)
    },
    checkPswUppercase: function() {
      return /[A-Z]+/.test(this.password)
    },
    checkPswDigit: function() {
      return /\d+/.test(this.password)
    },
    checkPswSpecialChars: function() {
      return /[^a-zA-Z0-9]+/.test(this.password)
    },
    filterPropRules() {
      this.propRules = this.rules.filter(
        rule => this.validationRules.includes[rule.title]
      )
    }
  },
  mounted() {
    this.setEvent()
  },
  computed: {
    input_type: function() {
      return this.isPswVisible ? 'text' : 'password'
    },
    rule_status: function() {
      return this.rules.map(value => (value.passed ? 'passed' : ''))
    },
    strength_level: function() {
      return `level level-${this.strength}`
    }
  },
  watch: {
    password: function() {
      this.rules.forEach(value => {
        value.passed = value.check()
      })
    },
    rule_status: function(array) {
      this.strength = array.filter(value => value === 'passed').length
    }
  }
}
</script>
<style scoped lang="scss">
.el-input{
    &.el-input--suffix{
      .el-input__inner {
          padding-right: 30px;
      }
    }
}
ul {
  margin-top: 1.5rem;
  color: #eee;

  li {
    font-weight: bold;
    color: lighten(red, 5%);
    transition: all 0.3s;
    margin-top: 0.5rem;

    span {
      margin-right: 1rem;
    }

    &.passed {
      color: lighten(green, 10%);
    }
  }
}

.level-container {
  display: flex;
  width: 20rem;
  margin-top: 0.5rem;

  .level {
    height: 5px;
    transition: all 0.5s;

    &-1 {
      background-color: #ff1a1a;
      width: 3.3rem;
    }
    &-2 {
      background-color: orangered;
      width: 6.6rem;
    }
    &-3 {
      background-color: yellow;
      width: 10rem;
    }
    &-4 {
      background-color: yellowgreen;
      width: 13.3rem;
    }
    &-5 {
      background-color: limegreen;
      width: 16.6rem;
    }
    &-6 {
      background-color: cadetblue;
      width: 20rem;
    }
  }
}
</style>
